<template>
  <div class="flex flex-grow w-auto justify-center flex-row">
    <div
      @click="showModal = true"
      class="flex flex-row items-center cursor-pointer"
    >
      <span
        class="linea text-3xl flex-1"
        v-if="cartStore.cartCount"
        :title="toolTipText"
        >x</span
      >
      <span
        class="linea text-3xl flex-1"
        v-if="!cartStore.cartCount"
        :title="toolTipText"
        >A</span
      >
      <span v-if="cartStore.cartCount" class="pl-2 pt-1"
        >{{ cartStore.cartCount }} item<span
          v-if="cartStore.cartCount > 1"
          >s</span
        >
        in cart</span
      >
    </div>
    <Dialog
      v-model:visible="showModal"
      modal
      :style="{ width: '100vw', minHeight: '100vh' }"
      @hide="showModal = false"
    >
      <cart-modal
        :min-hire-period="minHirePeriod"
        :show-modal="showModal"
        @close="showModal = false"
        :items="items"
      ></cart-modal>
    </Dialog>
  </div>
</template>

<script lang="ts">
import { defineComponent, ref } from "vue";
import CartModalComponent from "./ShoppingCart.vue";
import Dialog from "primevue/dialog";
import { useCartStore } from "../../stores/cart";

export default defineComponent({
  components: {
    Dialog,
    "cart-modal": CartModalComponent,
  },
  setup() {
    const showModal = ref(false);
    const cartStore = useCartStore();
    
    return {
      showModal,
      cartStore,
    };
  },
  data() {
    return {
      count: 0,
      items: [],
      data: {
        item: null,
      },
    };
  },
  computed: {
    toolTipText() {
      if (this.cartStore.cartCount) {
        return this.cartStore.cartCount + " products in cart";
      } else {
        return "Your cart is empty";
      }
    },
  },
});
</script>
